module.exports = __webpack_public_path__ + "img/微信图片_20240806171810.a7945908.png";